import { AlertCircle, CheckCircle2, Loader2, XIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import {
  ENTITY_BADGE_CLASSES,
  ENTITY_TYPE_LABELS,
  INTERACTION_TYPE_LABELS,
} from "../../constants";
import { SandboxEntity } from "../../types/entities";
import { InteractionsListItemProps } from "../../types/interactionListItem";

const EmbeddingStatusIcon = ({ entity }: { entity: SandboxEntity }) => {
  if (entity.isLoadingEmbedding)
    return (
      <Loader2 className="h-4 w-4 shrink-0 animate-spin text-muted-foreground" />
    );
  if (entity.embedding)
    return <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-500" />;
  if (entity.embeddingError)
    return <AlertCircle className="h-4 w-4 shrink-0 text-destructive" />;
  return null;
};

const InteractionsListItem = (props: InteractionsListItemProps) => {
  const { interaction, onRemove } = props;

  return (
    <li className="flex items-center gap-2 rounded-md border border-border px-3 py-2">
      <Badge
        variant="outline"
        className={cn(
          "shrink-0 text-xs capitalize",
          ENTITY_BADGE_CLASSES[interaction.entityType],
        )}
      >
        {ENTITY_TYPE_LABELS[interaction.entityType]}
      </Badge>
      <div className="flex-1 min-w-0">
        <p className="truncate text-sm leading-tight">
          {interaction.entity.name}
        </p>
        <p className="text-xs text-muted-foreground leading-tight">
          {INTERACTION_TYPE_LABELS[interaction.interactionType]}
        </p>
      </div>
      <EmbeddingStatusIcon entity={interaction.entity} />
      <button
        onClick={() => onRemove(interaction.id)}
        className="shrink-0 text-muted-foreground hover:text-destructive transition-colors"
        aria-label="Remove interaction"
      >
        <XIcon className="h-4 w-4" />
      </button>
    </li>
  );
};

export default InteractionsListItem;
